export default {
	JS_CMCC_CP:{
		interface:"https://jscmcc-h5activity.api.gitv.tv",
	},
	JS_CMCC_CP_ZX:{
		interface:"https://jscmcc-h5activity.api.gitv.tv",
	},
	JS_CMCC_KIDS:{
	  interface:"https://jscmcc-h5activity.api.gitv.tv",
	},
	JS_CMCC_KIDS_ZX:{
	  interface:"https://jscmcc-h5activity.api.gitv.tv",
	},
	CQ_CMCC:{
	  interface:"https://jscmcc-h5activity.api.gitv.tv",
	},
	JX_CMCC:{//江西移动
		interface:"https://jxcmcc-h5activity.api.gitv.tv",
	},
	JX_CMCC_CH:{//江西少儿
	  interface:"https://jxcmcc-h5activity.api.gitv.tv",
	},
	LNYD:{
	  interface:"https://lncmcc-h5activity.api.gitv.tv",
	},
	HBJD:{
	  interface:"https://hbcmcc-h5activity.api.gitv.tv",
	},
	NM_CMCC_FS:{//内蒙
	  interface:"https://hbcmcc-h5activity.api.gitv.tv",
	},
	SD_CMCC_JN:{
	  interface:"https://sdcmcc-h5activity.api.gitv.tv",
	},
	SD_CMCC_QD:{
	  interface:"https://sdcmcc-h5activity.api.gitv.tv",
	},
	SAXYD_ZX:{
	  interface:"https://saxcmcc-h5activity.api.gitv.tv",
	},
	SAXYD:{
	  interface:"https://saxcmcc-h5activity.api.gitv.tv",
	},
	HN_CMCC_RH:{
	  interface:"https://hncmcc-h5activity.api.gitv.tv",
	},
	HN_CMCC_JD_YP:{
	  interface:"https://hncmcc-h5activity.api.gitv.tv",
	},
	HN_CMCC_FS_YP:{
	  interface:"https://hncmcc-h5activity.api.gitv.tv",
	},
	HN_CMCC:{
	  interface:"https://hncmcc-h5activity.api.gitv.tv",
	},
	HNYD:{
	  interface:"https://hncmcc-h5activity.api.gitv.tv",
	},
	YNYDHW:{
	  interface:"https://yncmcc-h5activity.api.gitv.tv",
	},
	YNYDZX:{
	  interface:"https://yncmcc-h5activity.api.gitv.tv",
	},
	AH_CMCC:{
	  interface:"https://ahcmcc-h5activity.api.gitv.tv",
	},
	drawType:"0",//0:H5专题，1：签到，2：红包雨，3，答题
}



// WEBPACK FOOTER //
// ./src/config/topicData.js